import { Button, DialogActions } from "@mui/material";

import { useFilePickerState } from "../../state";

interface FilePickerFooterProps {
  onClose: () => void;
}

const getFileCountText = (count: number): string => {
  if (count === 0) {
    return "";
  }

  if (count === 1) {
    return "1 file";
  }

  return `${count} files`;
};

export const FilePickerFooter = (props: FilePickerFooterProps) => {
  const { onClose } = props;
  const { selectedFiles, setSelectionAsConfirmed } = useFilePickerState();

  const selectedFileCount = selectedFiles.length;
  const confirmDisabled = selectedFileCount === 0;
  const confirmText =
    selectedFileCount > 0
      ? `Select ${getFileCountText(selectedFileCount)}`
      : "Select file";

  return (
    <DialogActions sx={{ p: 2 }}>
      <Button
        data-testid="btn-file-picker-cancel"
        onClick={onClose}
        color="secondary"
        variant="contained"
      >
        Cancel
      </Button>
      <Button
        data-testid="btn-file-picker-confirm"
        onClick={setSelectionAsConfirmed}
        color="primary"
        disabled={confirmDisabled}
        variant="contained"
      >
        {confirmText}
      </Button>
    </DialogActions>
  );
};
